// extracted by mini-css-extract-plugin
export default {"cls1":"ButtonsPage-cls1_JTi","cls2":"ButtonsPage-cls2_PYU ButtonsPage-cls1_JTi","withThumbnail":"ButtonsPage-withThumbnail_xCE"};